module.exports = __webpack_public_path__ + "img/archivetagtest.71ec1662.svg";